import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Location } from './types'

export const LOCATIONS_QUERY: TypedDocumentNode<
  { locations: Location[] },
  {
    clientId: string
    applicationId: string
    search?: string
    limit?: number
    offset?: number
  }
> = gql`
  query Locations($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    locations(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id name address subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`

export const LOCATION_QUERY: TypedDocumentNode<{ location: Location | null }, { id: string }> = gql`
  query Location($id: ID!) {
    location(id: $id) {
      id client_id application_id name address subtitle description image image_low_res observations sort_order created_at updated_at
    }
  }
`
